
(function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get('cart') !== 'open') return;

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer.js-cart-drawer, cart-drawer[data-name="cart-drawer"]');
    if (!drawer) return;

    // Symmetry / theme custom element methods (if available)
    if (typeof drawer.open === 'function') return drawer.open();
    if (typeof drawer.show === 'function') return drawer.show();

    // Fallbacks
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));

    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open', 'open', 'active');
    document.body.classList.add('cart-drawer-open');
  }

  // Wait for custom elements + cart-drawer.js to be ready
  window.requestAnimationFrame(() => setTimeout(openDrawer, 50));

  // Optional: clean URL
  params.delete('cart');
  const cleaned =
    window.location.pathname +
    (params.toString() ? `?${params.toString()}` : '') +
    window.location.hash;
  window.history.replaceState({}, '', cleaned);
})();

